import { useStyles } from "../../Styles/styles";
import moment from "moment";
import WrappedKeyboardDateTimePicker from "../WrappedKeyboardDateTimePicker";
import { parseDateFlexible } from "../../utils/utils";

const ResponseTimes = ({ timeArr }) => {
  return (
    <>
      {timeArr.map(timeObj => (
        <TimeField key={timeObj?.timeName} {...timeObj} />
      ))}
    </>
  );
};

export default ResponseTimes;
const TimeField = ({ disabled, timeString, handleChange, timeName, label }) => {
  const classes = useStyles();

  const inputBlur = e => {
    if (e.key === "Escape" || e.key === "Enter") {
      e.target.blur();
    }
  };
  return (
    <WrappedKeyboardDateTimePicker
      className={classes.smallMatchMargin}
      InputLabelProps={{ shrink: true }}
      id={`date-time-${timeName}`}
      clearable
      disabled={disabled}
      variant="dialog"
      label={label}
      value={parseDateFlexible(timeString)}
      onChange={(date, value) => handleChange(value, timeName, date)}
      onDoubleClick={() => {
        if (!disabled) {
          handleChange("", timeName, moment());
        }
      }}
      onKeyDown={inputBlur}
      format="MM/DD/YY HH:mm:ss"
      ampm={false}
    />
  );
};
